// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxWidget_container__1L3vK","root":"CheckboxWidget_root__fsjm-","boxStyle":"CheckboxWidget_boxStyle__xO2Tv","errorBoxStyle":"CheckboxWidget_errorBoxStyle__5OG2J"};